import api, { auth } from '@/api';

// USED IN DEV MODE ONLY
export async function login(options: { email: string }) {
  const { email } = options;
  try {
    const response = await auth({
      email,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function logout() {
  const response = await api({
    method: 'post',
    url: '/auth/logout',
  });

  return response;
}
